// Tipos para Ordens de Serviço Recorrentes
import type { TFunction } from 'i18next';
import type { ServicoOS, EnderecoOS } from '@/types/ordemServico';

export type FrequenciaRecorrencia = 'semanal' | 'quinzenal' | 'mensal';

// Snapshot de uma linha de ordem_servico_itens (o que o formulário de OS
// recolhe por serviço). Reproduzido tal-qual ao gerar uma OS.
export interface ItemRecorrencia {
  servico_id: string;
  servico_nome: string;
  quantidade: number;
  valor_unitario: number;
  valor_total: number;
}

export interface RecorrenciaOS {
  id: string;
  organization_id: string;
  cliente_id: string;
  prestador_id: string | null;
  responsavel_id: string | null;
  frequencia: FrequenciaRecorrencia;
  proxima_data: string;
  ativa: boolean;
  servicos: ServicoOS[];
  itens: ItemRecorrencia[];
  endereco: EnderecoOS;
  valor_total: number;
  observacoes: string;
  duracao_estimada_minutos: number | null;
  criado_em: string;
  atualizado_em: string;
  // Relacionamentos expandidos
  cliente?: { id: string; nome: string | null; telefone: string } | null;
  prestador?: { id: string; profile: { id: string; nome: string } | null } | null;
}

export const getFrequenciaLabels = (
  t: TFunction,
): Record<FrequenciaRecorrencia, string> => ({
  semanal: t('recurrences.frequency.weekly'),
  quinzenal: t('recurrences.frequency.biweekly'),
  mensal: t('recurrences.frequency.monthly'),
});
